var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUnarchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15 5.2085H17.5C17.8452 5.2085 18.125 5.48832 18.125 5.8335V7.7085C18.125 8.05367 17.8452 8.3335 17.5 8.3335H12.8125H6.5625H2.5C2.15482 8.3335 1.875 8.05367 1.875 7.7085V5.8335C1.875 5.48832 2.15482 5.2085 2.5 5.2085H5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 8.3335V15.8335C16.875 15.9993 16.8092 16.1582 16.6919 16.2754C16.5747 16.3926 16.4158 16.4585 16.25 16.4585H3.75C3.58424 16.4585 3.42527 16.3926 3.30806 16.2754C3.19085 16.1582 3.125 15.9993 3.125 15.8335V8.3335",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.125 11.4585H11.875",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6562 4.11035L10.0046 1.45871L7.35297 4.11035",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6.4585L10 1.4585",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnarchive);
export default __webpack_public_path__ + "static/media/icon-unarchive.702b07246e3d7dd3fef65d3cae2853c9.svg";
export { ForwardRef as ReactComponent };